import Vue from 'vue';
import VueRouter from 'vue-router';
import Home from '@/views/Home.vue';
import About from '@/views/About.vue';
import layout from "@/views/layout.vue";

const originalPush = VueRouter.prototype.push
VueRouter.prototype.push = function push(location) {
  return originalPush.call(this, location).catch(err => err)
}

Vue.use(VueRouter)

const routes = [
  {
    path: '/',
    name: '/',
    component:Home
  },
  {
    path: '/blog',
    name: 'Blog',
    component: layout,
    redirect: '/blog/home',
    children: [
      {
        path: '/blog/home',
        name: 'home',
        component: () => import('@/components/projectList.vue')
      },
      {
        path: '/blog/traval',
        name: 'traval',
        component: () => import('@/components/FootPrint.vue')
      },
      {
        path: '/blog/wechat',
        name: 'wechat',
        component: () => import('@/components/wechat.vue')
      },
      {
        path: '/blog/time-line',
        name: 'time-line',
        component: () => import('@/components/timeLine.vue')
      },
      {
        path: '/blog/tags',
        name: 'tags',
        component: () => import('@/components/blogTags.vue')
      },
      {
        path: '/blog/category',
        name: 'category',
        component: () => import('@/components/blogList.vue')
      },
      {
        path: '/blog/articles',
        name: 'articles',
        component: () => import('@/components/mdBlogContent.vue'),
      },
    ]
  },
  {
    path: '/projects',
    name: 'projects',
    children: [
      {
        path: '/love-talk',
        name: 'love-talk',
        component: About
      },
      {
        path: '/Maybe',
        name: 'Maybe',
        component: About
      },
    ]
  },
  {
    path: '/about-me',
    name: 'myself',
    component: () => import('@/components/resume/resumeHome.vue')
  },
  {
    path: '/schedule',
    name: 'schedule',
    component: () => import('@/components/myCalendar.vue')
  },
  {
    path: '/cheer-on',
    name: 'cheer-on',
    component: () => import('@/components/loveTalk/loveTalk.vue')
  },
  {
    path: '*',
    name: '404',
    component: () => import('@/views/Page404')
  },
]

const router = new VueRouter({
  mode:"hash",
  routes:routes
})

export default router
